import type { NewAxisField, Testimonial } from "@/api/pipeline.service";

export const RESEARCH_ID_FIELDS = [
  { key: "editionId", label: "Edition" },
  { key: "rankingEntityId", label: "Region" },
  { key: "bpaId", label: "Practice" },
  { key: "editionBpaId", label: "Edition practice" },
  { key: "rankingTableId", label: "Table" },
] as const satisfies readonly { key: NewAxisField; label: string }[];

export function hasResearchIds(testimonial: Pick<Testimonial, NewAxisField>): boolean {
  return RESEARCH_ID_FIELDS.some(({ key }) => testimonial[key] != null);
}
